<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    
  <path d="M1099.5 1.5a60.1 60.1 0 0 0-46 43 61.7 61.7 0 0 0 5.1 41.5c18.7 35.6 76.1 41.2 104.5 10.2a56.8 56.8 0 0 0 8.3-63.3 63.8 63.8 0 0 0-35.7-29.5 80.8 80.8 0 0 0-36.2-1.9zM1216 203.2c0 119.8.4 197.8 1 206.8 4 56.7 17.3 104 41.5 147 8.5 15.1 27.5 43.1 28.7 42.4 1.5-1 80.1-58.5 81-59.3a75 75 0 0 0-8.4-14.1 234 234 0 0 1-38.4-99.7c-3-21.5-3.4-48.1-3.4-230.6V11h-102v192.2zM158 155.6C92 161.4 46.8 185.5 26.1 226a115.8 115.8 0 0 0-12.7 62c.8 24.3 5.3 40.1 16.1 56.7 10.4 15.9 24.8 27.7 46.7 38.3 20.8 10 43.8 16.9 85.9 25.5 73.4 15.1 103.6 29.1 111.3 51.8 4.3 12.7.2 28.2-10.4 38.7-18.7 18.7-61.3 25.3-98.8 15.5a93.2 93.2 0 0 1-65.7-60c-1.5-3.9-2.9-6-3.8-5.9-2.8.3-93.2 24.6-94 25.3-1 1 4.2 15.9 9.2 26.7a161.5 161.5 0 0 0 37.3 49.3c16.4 14 40.5 27.8 61.3 35.1a300 300 0 0 0 49.6 12.1c12.3 1.9 18.5 2.3 41.9 2.3 23.6 0 29.6-.3 41.8-2.2 60.3-9.4 101.1-34.5 121.3-74.5 16.8-33.1 18.1-77.5 3.3-107.1-12-23.8-34.9-43.1-68.4-57.4-24.6-10.6-51.2-17.9-98.8-27.2-33.3-6.5-43.9-9.2-56.5-14.2-15.5-6.1-25.7-15-29.8-25.7-1.7-4.6-2-7.2-1.7-14.1a30.2 30.2 0 0 1 11-23.7 61.3 61.3 0 0 1 27.7-14 82.1 82.1 0 0 1 26.6-2.7c19.2-.1 28 1.3 42.5 6.8 22.2 8.3 39 26 46.6 49.1l2.9 8.3c.4.4 88.9-24 89.8-24.8 2.2-2-11.1-32.5-19.9-45.5-26.9-40-69.2-64.8-124.4-73-11-1.6-45.8-2.8-56-1.9zM1557.5 156c-56.1 5.9-103.3 30.1-136.7 69.9-26.7 32-42.7 69.2-49.5 115.6a353.9 353.9 0 0 0 0 69.8c8.1 52.9 27.5 94.1 60.6 128.1 40.6 41.6 94.7 62.5 156.1 60.3 69.5-2.5 125.3-33.2 162.3-89.2 5.4-8.2 18.7-33.8 18.7-36.1 0-.9-92.8-26-93.4-25.3-.2.2-2.1 3.8-4.1 7.9-16.2 32.4-44.5 50-83.1 51.7a106.7 106.7 0 0 1-81.7-29.6 116.8 116.8 0 0 1-35.3-74.4l-.7-7.7h313.1l.7-9.8c1-12.6 0-39.9-2-53a232 232 0 0 0-21.4-70.7 191.8 191.8 0 0 0-147.1-106c-12.3-1.9-45-2.7-56.5-1.5zm39.1 84.5a105.8 105.8 0 0 1 62 31 94.4 94.4 0 0 1 25.9 45.8l.7 3.7H1473l.6-2.8a100.6 100.6 0 0 1 53.9-66.8c22.3-11 44.6-14.5 69.1-10.9zM410 213.7c0 130.5 4.2 206.7 14.1 256.9 9.4 48 22.4 77.8 43.4 98.9 20 20.2 46.5 30.5 77.8 30.5 43.9-.1 80.5-22.6 100.4-61.6 14.4-28.3 21.9-69.7 27.3-151.4 5.2-78 11.2-111.8 21.6-121.2 7-6.2 15 0 20.3 15.7 6.5 19.6 9.3 44.9 14.1 127.5 4.2 72.8 13.6 111.5 34.8 143.4a133 133 0 0 0 27.7 28.3 116.4 116.4 0 0 0 114.2 7.8c30-15.2 50.3-43.1 61.9-85.4 7.8-28.5 11.1-54.4 13.4-106.1 4-90.1 11.8-127.8 27.5-133l3.5-1.2V164h-2.7c-6.4 0-21.4 2.4-29.3 4.6-30.9 8.9-54.7 29.7-70.5 61.9-15.7 32.1-21.8 66.9-27.5 157-3.2 51-6.4 77.2-11.3 94.1-7 24.4-18.6 26.7-27.2 5.5-8-19.6-12.7-52.4-16.5-116.1-3.8-62.9-8.2-92.3-18.1-121.5-7.5-22.2-16.6-38-29.8-51.8a100.5 100.5 0 0 0-44.1-28.2 113.2 113.2 0 0 0-51.3-4c-52.9 8-87.1 48.5-99.6 118.2-4.4 24.3-6.2 42.6-9.1 90.3-4 66.6-8.5 96.9-17 115.5-6 13.2-13 15.6-20.6 7.3C526.7 485 517.5 445.1 514 396c-1.8-26.3-4.6-154.2-5-227.3V164h-99v49.7zM1063 380.5V597h103l-.2-216.3-.3-216.2-51.2-.3-51.3-.2v216.5z"/>

  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: '',
    },
    name: {
      type: String,
      required: false,
      default: 'PtcySwile',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 1785 600',
    },
  },
};
</script>

<style scoped>
  
</style>